const TailwindcssIcon = () => (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 6.403c-4.267 0-6.933 2.133-8 6.398 1.6-2.133 3.467-2.932 5.6-2.399 1.217 0.304 2.087 1.187 3.050 2.164 1.569 1.592 3.384 3.434 7.35 3.434 4.266 0 6.933-2.133 8-6.398-1.6 2.133-3.466 2.933-5.6 2.4-1.217-0.304-2.087-1.187-3.050-2.164-1.569-1.592-3.384-3.434-7.35-3.434zM8 16c-4.266 0-6.933 2.133-8 6.398 1.6-2.133 3.466-2.933 5.6-2.399 1.217 0.305 2.087 1.187 3.050 2.164 1.569 1.592 3.384 3.434 7.35 3.434 4.267 0 6.933-2.133 8-6.398-1.6 2.133-3.467 2.933-5.6 2.399-1.217-0.304-2.087-1.187-3.050-2.164-1.569-1.592-3.384-3.434-7.35-3.434z" />
    </svg>
);

export default TailwindcssIcon;
